<template>

    <div class="page" v-if="true" ref="mainPage">

        <router-view></router-view>

    </div>

    <div class="loading" v-else><span class="sr-only">LOADING</span></div>

    <teleport to="#change-lang">
        <a style="cursor:pointer" @click="changeLang">{{ copydeck.footer.menu_change_lang[lang]}}</a>
    </teleport>

</template>

<script>

export default {
    name       : "App",
    components : {},
}

</script>


<script setup>

import { onMounted, computed, inject, ref } from "vue";
import { useMainStore }                     from "./stores/main";
import { storeToRefs }                      from "pinia";
import { useRoute, useRouter }              from "vue-router";
import { useTitle, useUrlSearchParams }     from '@vueuse/core';


let store                                                               = useMainStore();
const { loadDatas }                                                     = store;
const { ready, user, lang, userIsReady, copydeck, lastPage, routeName } = storeToRefs( store )
const { reset, setGoogleTag, changeLang, getOtherUrl, getRoute }        = (store)
//let copydeck = useCopydeck();


let router = useRouter();
let route  = useRoute();
let title  = useTitle()


let mainPage = ref( null );

let otherUrl = computed ( getOtherUrl );


onMounted( async () =>
{

    if ( [ "Privacy" ].includes( route.name ) )
    {
        return;
    }

    let strPage = lastPage.value;

    if ( ["Confirmation", "",].includes( strPage ) )
    {

        router.push( getRoute('introduction') );
    }

    // 2023-10-19 override in case we want to jump straight to the recap
    // if ( (route?.name ?? '') === 'Recap' )
    // {
    //     strPage = 'Recap';
    // }

    if ( (route?.name ?? '') !== 'Recap' )
    {

    }


    // const postSizeUpdate = () => {
    //     const message = {
    //         type   : 'resize',
    //         height : mainPage.value.getBoundingClientRect().height
    //     };
    //
    //     parent.postMessage( message, '*' );
    // }
    //
    // // whenever the main container size changes, tell the parent iFrame
    // const mainAppResizeObserver = new ResizeObserver( ( entries ) => {
    //     for ( const entry of entries ) {
    //         postSizeUpdate()
    //     }
    // } );
    // mainAppResizeObserver.observe( mainPage.value );
    //
    //
    //
    //
    // postSizeUpdate();

    // i don't think we need this anymore because of the resizeObserver
    // setInterval( postSizeUpdate, 150 );


} )


</script>


<style>


</style>
